import { AppBar, Autocomplete, Box, Button, MenuItem, Select, TextField, InputAdornment, OutlinedInput, IconButton, styled, createTheme } from '@mui/material'
import React, { useEffect, useRef, useState } from 'react'
import { useNavigate } from 'react-router-dom'
import * as api from '../services/api'
import Loader from '../../components/Loader'
import styles from '../register&signIn/login.module.css'
import logo from '../../assets/icons/logo.svg'
import KeyboardBackspaceIcon from '@mui/icons-material/KeyboardBackspace';
import AccountCircleIcon from '@mui/icons-material/AccountCircle';
import dayjs from 'dayjs'
import { LocalizationProvider } from '@mui/x-date-pickers'
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { DemoContainer, DemoItem } from '@mui/x-date-pickers/internals/demo';
import { MobileDatePicker } from '@mui/x-date-pickers/MobileDatePicker';
import ModalCalendar from '../../components/modal/ModalCalendar'
import CalendarTodayIcon from '@mui/icons-material/CalendarToday';
import moment from 'moment/moment'
import camera from '../../assets/icons/camera.svg'

function Register() {
    const navigate = useNavigate()
    const [loading, setLoading] = useState(false)

    const [gender, setGender] = useState([])
    const [titlename, setTitlename] = useState([])
    const [department, setDepartment] = useState([])
    const [usertype, setUsertype] = useState([])

    const [openCalendar, setOpenCalendar] = useState(false)
    const [disabledDay, setDisabledDay] = useState([])

    const [data, setData] = useState({
        image: "",
        user_type: "", //ประเภทผู้ใช้งาน
        pid: "", //เลขบัตรประชาชน
        sex: "", //เพศ
        title_name: "", //ยศ
        fname: "", //ชื่อ
        lname: "", //นามสกุล
        email: "",
        phone: "", //หมายเลขโทรศัพท์
        department_name: "", //สังกัด
        department_code: "",
        password: "",
        confirm_password: "",
        birthday: ""
    });

    const [isValidphone, setIsValidphone] = useState(false);
    const [isValidpid, setIsValidpid] = useState(false);

    const imgRef = useRef(null)
    const [selectedFile, setSelectedFile] = useState(null);

    useEffect(() => {
        findGender()
        findTitleName()
        findUserGroup()
        findDepartmentFixToken()
    }, [])

    const handleChange = (e) => {
        const { name, value } = e.target;
        setData({ ...data, [name]: value });
    };

    const clickRegister = () => {
        let inform = {
            image_url: data['image'],
            user_type: data['user_type'],
            card_id: data['pid'],
            gender: data['sex'],
            titlename: data['title_name'],
            firstname: data['fname'],
            lastname: data['lname'],
            email: data['email'],
            phone: data['phone'],
            department_code: data['department_code'],
            password: data['password'],
            dob: formatDate(data['birthday'])
        }
        console.log(inform)
        register(inform)
    }

    const findGender = async () => {
        setLoading(true)
        let res = await api.gender()
        setLoading(false)
        if (res) {
            if (res['data']['code'] == 200) {
                setGender(res['data']['data'])
            } else {
                //alert(res['data']['message'])
            }
        } else {
            alert('ไม่ตอบสนอง')
        }
    }

    const findTitleName = async () => {
        setLoading(true)
        let res = await api.titleName()
        setLoading(false)
        if (res) {
            if (res['data']['code'] == 200) {
                let option = []
                for (let i = 0; i < res['data']['data'].length; i++) {
                    if (res['data']['data'][i]) {
                        option.push({
                            key: res['data']['data'][i]['value'],
                            label: res['data']['data'][i]['name']
                        })
                    }
                    const unique = [...new Map(option.map((m) => [m.key, m])).values()] //กรองชื่อซ้ำ
                    // console.log(unique)
                    setTitlename(unique)
                }
            } else {
                //alert(res['data']['message'])
            }
        } else {
            alert('ไม่ตอบสนอง')
        }
    }

    const findUserGroup = async () => {
        setLoading(true)
        let res = await api.findUserGroup()
        setLoading(false)
        if (res) {
            if (res['data']['code'] == 200) {
                // console.log(res['data']['data'])
                setUsertype(res['data']['data'])
            } else {
                //alert(res['data']['message'])
            }
        } else {
            alert('ไม่ตอบสนอง')
        }
    }

    const findDepartmentFixToken = async () => {
        setLoading(true)
        let res = await api.findDepartmentFixToken()
        setLoading(false)
        if (res) {
            if (res['data']['code'] == 200) {
                let option = []
                for (let i = 0; i < res['data']['data'].length; i++) {
                    if (res['data']['data'][i]) {
                        option.push({
                            key: res['data']['data'][i]['department_code'],
                            label: res['data']['data'][i]['department_name']
                        })
                    }
                    const unique = [...new Map(option.map((m) => [m.key, m])).values()] //กรองชื่อซ้ำ
                    // console.log(unique)
                    setDepartment(unique)
                }
            } else {
                //alert(res['data']['message'])
            }
        } else {
            alert('ไม่ตอบสนอง')
        }
    }

    const formatDate = (date) => {
        var d = new Date(date),
            month = '' + (d.getMonth() + 1),
            day = '' + d.getDate(),
            year = d.getFullYear();

        if (month.length < 2)
            month = '0' + month;
        if (day.length < 2)
            day = '0' + day;

        return [year, month, day].join('-');
    }

    const register = async (inform) => {
        setLoading(true)
        let res = await api.register(inform)
        setLoading(false)
        if (res) {
            if (res['data']['code'] == 200) {
                navigate('/manageUsers')
            } else {
                //alert(res['data']['message'])
            }
        } else {
            alert('ไม่ตอบสนอง')
        }
    }

    const convertDate = (dataDate) => {
        const date = new Date(dataDate)
        const optionDate = {
            year: 'numeric',
            month: 'long',
            day: 'numeric',
        }
        const thaiLocale = 'th-TH';
        const formattedDate = date.toLocaleDateString(thaiLocale, optionDate)

        const newDate = `${formattedDate}`
        return newDate
    }

    const handleClickImage = () => {
        imgRef.current.click();
    }
    const handleChangeImage = async (event) => {
        // const file = event.target.files && event.target.files[0];

        // let formData = new FormData()
        // formData.append('file', file)

        // setLoading(true)
        // let res = await api.uploadFile2('user',formData)
        // setLoading(false)
        // if (res) {
        //     if (res['data']['code'] === 200) {
        //         // console.log(res['data']['data']['url'])
        //         setSelectedFile(res['data']['data']['url'])
        //         setData({ ...data, 'image': res['data']['data']['url'] })
        //     } else {
        //         //alert(res['data']['message'])
        //     }
        // } else {
        //     alert('ไม่ตอบสนอง')
        // }
        const file = event.target.files && event.target.files[0];
        if (!file) return;

        let formData = new FormData()
        formData.append('file', file)
        formData.append('file_path', `/profile`)
        formData.append('file_source', 'profile')
        formData.append('file_name', file.name)

        setLoading(true)
        let res = await api.uploadFileImage('profile', formData)
        setLoading(false)
        if (!res) return alert('ไม่ตอบสนอง')

        const code = res['code']
        if (code === 200) {
            setSelectedFile(res['data']['file_api_url'])
            setData({ ...data, 'image': res['data']['file_api_url'] })
        } else if (code === 403) {
            alert('รูปประกอบงานสร้างเสริม รองรับไฟล์เฉพาะ .jpeg, .jpg, .png เท่านั้น')
        } else {
            console.log('error', res)
            alert('ไม่ตอบสนอง')
        }
    }

    return (
        <>
            <Loader loading={loading} />

            {openCalendar &&
                <ModalCalendar
                    onClose={() => { setOpenCalendar(false) }}
                    onSubmit={() => { setOpenCalendar(false) }}
                    value={
                        data['birthday'] ? dayjs(moment(data['birthday']['$d']).format('YYYY-MM-DD')) : dayjs(moment(new Date()).format('YYYY-MM-DD'))
                    }
                    setValue={(e) => {
                        setData({ ...data, birthday: e });
                    }}
                    disableDay={disabledDay}
                />
            }


            <Box sx={design.container}>
                <Box sx={design.mainSection}>
                    <Box sx={{
                        display: 'flex',
                        alignItems: 'center',
                        gridGap: '10px',
                    }}>
                        <KeyboardBackspaceIcon sx={{ fontSize: '20px' }} />
                        <Box sx={{
                            cursor: 'pointer'
                        }}
                            onClick={() => { navigate('/manageUsers') }}
                        >กลับไป จัดการผู้ใช้งาน</Box>
                    </Box>
                    <Box sx={{ mt: 2, color: '#478F96', fontWeight: 600 }}>เพิ่มผู้ใช้งานใหม่</Box>

                    <Box sx={{
                        display: 'flex',
                        justifyContent: 'center',
                        fontSize: '20px',
                        "@media (max-width: 1100px)": {
                            fontSize: '16px',
                        },
                        "@media (max-width: 800px)": {
                            fontSize: '14px',
                        },
                    }}>
                        <Box sx={{
                            display: 'grid',
                            gridGap: '20px',
                            width: '700px',
                            "@media (max-width: 1100px)": {
                                width: '500px'
                            },
                            "@media (max-width: 800px)": {
                                width: '100%'
                            },
                        }}>
                            <Box sx={{
                                display: 'grid',
                                justifyItems: 'center'
                            }}>
                                {selectedFile ?
                                    <Box sx={{ position: 'relative' }}>
                                        <input
                                            type="file"
                                            ref={imgRef}
                                            style={{ display: "none" }}
                                            accept=".jpg,.jpeg,.png"
                                            onChange={(e) => {
                                                handleChangeImage(e)
                                            }}
                                        />
                                        <img
                                            style={{ width: '100px', height: '100px', borderRadius: '50%', border: '1px solid #BACCE1' }}
                                            src={data['image']}
                                            onClick={handleClickImage}
                                        />
                                        <img onClick={handleClickImage} src={camera} style={{ cursor: 'pointer', position: 'absolute', bottom: '8px', right: '5px' }} />
                                    </Box>
                                    :
                                    <Box sx={{ position: 'relative' }}>
                                        <input
                                            type="file"
                                            ref={imgRef}
                                            style={{ display: "none" }}
                                            accept=".jpg,.jpeg,.png"
                                            onChange={(e) => {
                                                handleChangeImage(e)
                                            }}
                                        />
                                        <Box
                                            sx={{ width: '100px', height: '100px', borderRadius: '50%', backgroundColor: '#BACCE1', border: '1px solid #BACCE1' }}
                                            onClick={handleClickImage}
                                        ></Box>
                                        <img onClick={handleClickImage} src={camera} style={{ cursor: 'pointer', position: 'absolute', bottom: '8px', right: '5px' }} />
                                    </Box>
                                }
                            </Box>

                            <Box>
                                <Box>ประเภทผู้ใช้งาน</Box>
                                <Select
                                    size="small"
                                    fullWidth
                                    value={data['user_type'] || "null"}
                                    name={"user_type"}
                                    onChange={handleChange}
                                >
                                    <MenuItem value="null" disabled>
                                        เลือกประเภทผู้ใช้งาน
                                    </MenuItem>
                                    {usertype.map((i, idx) => (
                                        <MenuItem key={idx} value={i['group_code']}>{i['group_name']}</MenuItem>
                                    ))}
                                </Select>
                            </Box>

                            <Box>
                                <Box>เลขบัตรประจำตัวประชาชน</Box>
                                <TextField
                                    placeholder="กรอกเลขบัตรประจำตัวประชาชน"
                                    size="small"
                                    fullWidth
                                    value={data["pid"]}
                                    name="pid"
                                    onChange={(e) => {
                                        const value = e.target.value;

                                        // Restrict input to digits only
                                        if (/^\d*$/.test(value)) {
                                            setData({ ...data, pid: value });
                                            const regex = /^\d{13}$/;
                                            setIsValidpid(regex.test(value)); // Validates if the input has exactly 13 digits
                                        }
                                    }}
                                    sx={{
                                        "& .MuiOutlinedInput-root": {
                                            "& fieldset": {
                                                borderColor: isValidpid || data["pid"] === '' ? '' : 'red', // Highlight red for invalid input
                                            },
                                        },
                                    }}
                                    helperText={
                                        data["pid"].length > 0 && !isValidpid
                                            ? "กรุณากรอกเลขบัตรประจำตัวประชาชนให้ครบ 13 หลัก"
                                            : ""
                                    } // Display an error message if input is invalid
                                    FormHelperTextProps={{
                                        style: { color: 'red' }, // Style the error text in red
                                    }}
                                />

                            </Box>

                            <Box>
                                <Box>เพศ</Box>
                                <Select
                                    size="small"
                                    fullWidth
                                    value={data["sex"] || "null"}
                                    name={"sex"}
                                    onChange={handleChange}
                                >
                                    <MenuItem value="null" disabled>
                                        เลือกเพศ
                                    </MenuItem>
                                    {gender.map((i, idx) => (
                                        <MenuItem key={idx} value={i['value']}>{i['name']}</MenuItem>
                                    ))}
                                </Select>
                            </Box>

                            <Box>
                                <Box>สังกัด</Box>
                                <Autocomplete
                                    fullWidth
                                    size='small'
                                    options={department}
                                    value={data['department_name']}
                                    name='department_name'
                                    onChange={(e, value) => {
                                        setData({ ...data, 'department_name': value?.['label'], 'department_code': value?.['key'] });
                                    }}
                                    renderInput={(params) =>
                                        <TextField {...params}
                                            placeholder="เลือกสังกัด"
                                        />
                                    }
                                />
                            </Box>

                            <Box>
                                <Box>ยศ</Box>
                                <Autocomplete
                                    fullWidth
                                    size='small'
                                    options={titlename}
                                    value={data["title_name"]}
                                    name='title_name'
                                    onChange={(e, value) => {
                                        setData({ ...data, 'title_name': value?.['label'] });
                                    }}
                                    renderInput={(params) =>
                                        <TextField {...params}
                                            placeholder="เลือกยศ"
                                        />
                                    }
                                />
                            </Box>

                            <Box>
                                <Box sx={{ display: 'flex', gridGap: '10px' }}>
                                    <Box>ชื่อและนามสกุลที่แสดงในระบบ</Box>
                                    <Box sx={{ color: '#687982' }}>กรุณาใช้ชื่อและนามสกุลจริง</Box>
                                </Box>
                                <Box sx={{
                                    display: 'grid',
                                    gridTemplateColumns: '1fr 1fr',
                                    gridGap: '20px',
                                    "@media (max-width: 800px)": {
                                        gridTemplateColumns: '1fr',
                                    },
                                }}>
                                    <TextField
                                        placeholder="ชื่อ"
                                        size="small"
                                        fullWidth
                                        value={data["fname"]}
                                        name={"fname"}
                                        onChange={handleChange}
                                    />
                                    <TextField
                                        placeholder="นามสกุล"
                                        size="small"
                                        fullWidth
                                        value={data["lname"]}
                                        name={"lname"}
                                        onChange={handleChange}
                                    />
                                </Box>
                            </Box>

                            <Box sx={{
                                display: 'grid',
                                gridTemplateColumns: '1fr 1fr',
                                gridGap: '20px',
                                "@media (max-width: 800px)": {
                                    gridTemplateColumns: '1fr',
                                },
                            }}>
                                <Box>
                                    <Box>อีเมล</Box>
                                    <TextField
                                        placeholder="กรอกอีเมล"
                                        size="small"
                                        fullWidth
                                        value={data["email"]}
                                        name={"email"}
                                        onChange={handleChange}
                                    />
                                </Box>
                                <Box>
                                    <Box>เบอร์โทร</Box>
                                    <TextField
                                        placeholder="กรอกเบอร์โทร"
                                        size="small"
                                        fullWidth
                                        value={data["phone"]}
                                        name={"phone"}
                                        onChange={(e) => {
                                            const value = e.target.value;
                                            const regex = /^\d{10}$/;

                                            // Limit the input to digits only
                                            if (/^\d*$/.test(value)) {
                                                setData({ ...data, phone: value });
                                                setIsValidphone(regex.test(value)); // Check validity for exactly 10 digits
                                            }
                                        }}
                                        sx={{
                                            "& .MuiOutlinedInput-root": {
                                                "& fieldset": {
                                                    borderColor: isValidphone || data["phone"] === '' ? '' : 'red', // Red border for invalid input
                                                },
                                            },
                                        }}
                                        helperText={
                                            data["phone"].length > 10
                                                ? "กรุณากรอกเบอร์โทรไม่เกิน 10 หลัก"
                                                : !isValidphone && data["phone"] !== ""
                                                    ? "กรุณากรอกเบอร์โทรให้ครบ 10 หลัก"
                                                    : ""
                                        } // Show error hint if phone is too long or invalid
                                        FormHelperTextProps={{
                                            style: { color: 'red' }, // Make error text red
                                        }}
                                    />

                                </Box>
                            </Box>

                            <Box sx={{
                                display: 'grid',
                                gridTemplateColumns: '1fr 1fr',
                                gridGap: '20px',
                                "@media (max-width: 800px)": {
                                    gridTemplateColumns: '1fr',
                                },
                            }}>
                                <Box>
                                    <Box>ตั้งค่ารหัสผ่าน</Box>
                                    <TextField
                                        type='password'
                                        placeholder="รหัสผ่าน"
                                        size="small"
                                        fullWidth
                                        value={data["password"]}
                                        name={"password"}
                                        onChange={handleChange}
                                    />
                                </Box>
                                <Box>
                                    <Box>ยืนยันรหัสผ่าน</Box>
                                    <TextField
                                        type='password'
                                        placeholder="ยืนยันรหัสผ่าน"
                                        size="small"
                                        fullWidth
                                        value={data["confirm_password"]}
                                        name={"confirm_password"}
                                        onChange={handleChange}
                                    />
                                </Box>
                            </Box>

                            <Box>
                                <Box>วันเกิด</Box>
                                <TextField
                                    fullWidth
                                    size='small'
                                    value={data['birthday'] === '' ? 'เลือกวันเกิด' : convertDate(data['birthday'])}
                                    InputProps={{
                                        inputProps: {
                                            readOnly: true,
                                        },
                                        endAdornment: (
                                            <InputAdornment position="end">
                                                <IconButton
                                                    onClick={() => { setOpenCalendar(true) }}
                                                >
                                                    <CalendarTodayIcon />
                                                </IconButton>
                                            </InputAdornment>
                                        )
                                    }}
                                />
                            </Box>
                            <Box sx={{ textAlign: 'center' }}>
                                <Button
                                    variant="contained"
                                    sx={{
                                        width: "150px",
                                        "@media (max-width: 800px)": {
                                            width: "100px",
                                        },
                                    }}
                                    onClick={() => {
                                        if (!data['image']) {
                                            return alert('กรุณาเลือกรูป')
                                        }

                                        if (!data['user_type']) {
                                            return alert('กรุณาเลือกประเภทผู้ใช้งาน')
                                        }

                                        if (!data['pid']) {
                                            return alert('กรุณากรอกเลขบัตรประจำตัวประชาชน')
                                        }

                                        if (!data['sex']) {
                                            return alert('กรุณาเลือกเพศ')
                                        }
                                        if (!data['title_name']) {
                                            return alert('กรุณาเลือกยศ')
                                        }
                                        if (!data['fname']) {
                                            return alert('กรุณากรอกชื่อ')
                                        }
                                        if (!data['lname']) {
                                            return alert('กรุณากรอกนามสกุล')
                                        }
                                        if (!data['email']) {
                                            return alert('กรุณากรอกอีเมล')
                                        }

                                        if (!data['phone']) {
                                            return alert('กรุณากรอกเบอร์โทรศัพท์')
                                        }

                                        if (!data['department_code']) {
                                            return alert('กรุณาเลือกสังกัด')
                                        }
                                        if (!data['password']) {
                                            return alert('กรุณากรอกรหัสผ่าน')
                                        }
                                        if (!data['confirm_password']) {
                                            return alert('กรุณากรอกยืนยันรหัสผ่าน')
                                        }
                                        if (!data['birthday']) {
                                            return alert('กรุณาเลือกวันเกิด')
                                        }
                                        if (data['password'] !== data['confirm_password']) {
                                            return alert('รหัสผ่านไม่ตรงกัน')
                                        }
                                        clickRegister()
                                    }}
                                >ลงทะเบียน</Button>
                            </Box>
                        </Box>
                    </Box>
                </Box>
            </Box>
        </>
    )
}

const design = {
    container: {
        display: "flex",
        bgcolor: "neutral.light",
    },
    mainSection: {
        px: { xl: 4, lg: 4, md: 4, sm: 2, xs: 2 },
        py: { xl: 4, lg: 4, md: 4, sm: 2, xs: 2 },
        width: "100%",
        height: "100%",
        overflow: "auto",
    },
};

const StyledMobileDatePicker = styled(MobileDatePicker)({
    '& .MuiTextField-root': {
        margin: '20px',
    },
    "& .MuiInputBase-input": {
        padding: '8.5px 14px'
    }
});

const DatePicker = {
    width: '100%'
}

export default Register
